<template>
  <div class="chat-bubble" @click="openChat()" :style="launcherStyle">
    <span class="bubble-label">CHAT</span>
    <img
      src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyNiAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE4LjM3NSA3LjVDMTguMzc1IDMuNzE4NzUgMTQuMzM1OSAwLjYyNSA5LjQzNzUgMC42MjVDNC40OTYwOSAwLjYyNSAwLjUgMy43MTg3NSAwLjUgNy41QzAuNSA5LjAwMzkxIDEuMTAxNTYgMTAuMzM1OSAyLjEzMjgxIDExLjQ1MzFDMS41MzEyNSAxMi43ODUyIDAuNTg1OTM4IDEzLjgxNjQgMC41ODU5MzggMTMuODE2NEMwLjUgMTMuOTAyMyAwLjQ1NzAzMSAxNC4wNzQyIDAuNSAxNC4yMDMxQzAuNTg1OTM4IDE0LjMzMiAwLjY3MTg3NSAxNC4zNzUgMC44NDM3NSAxNC4zNzVDMi4zOTA2MiAxNC4zNzUgMy42Nzk2OSAxMy44NTk0IDQuNjI1IDEzLjMwMDhDNiAxMy45ODgzIDcuNjc1NzggMTQuMzc1IDkuNDM3NSAxNC4zNzVDMTQuMzM1OSAxNC4zNzUgMTguMzc1IDExLjMyNDIgMTguMzc1IDcuNVpNMjMuNjE3MiAxNi45NTMxQzI0LjYwNTUgMTUuODM1OSAyNS4yNSAxNC41MDM5IDI1LjI1IDEzQzI1LjI1IDEwLjE2NDEgMjIuOTI5NyA3LjY3MTg4IDE5LjY2NDEgNi42NDA2MkMxOS43MDcgNi45NDE0MSAxOS43NSA3LjI0MjE5IDE5Ljc1IDcuNUMxOS43NSAxMi4wNTQ3IDE1LjEwOTQgMTUuNzUgOS40Mzc1IDE1Ljc1QzguOTY0ODQgMTUuNzUgOC40OTIxOSAxNS43NSA4LjA2MjUgMTUuNzA3QzkuMzk0NTMgMTguMTU2MiAxMi41NzQyIDE5Ljg3NSAxNi4zMTI1IDE5Ljg3NUMxOC4wNzQyIDE5Ljg3NSAxOS43MDcgMTkuNDg4MyAyMS4wODIgMTguODAwOEMyMi4wMjczIDE5LjM1OTQgMjMuMzE2NCAxOS44NzUgMjQuOTA2MiAxOS44NzVDMjUuMDM1MiAxOS44NzUgMjUuMTY0MSAxOS44MzIgMjUuMjA3IDE5LjcwMzFDMjUuMjUgMTkuNTc0MiAyNS4yNSAxOS40MDIzIDI1LjEyMTEgMTkuMzE2NEMyNS4xMjExIDE5LjMxNjQgMjQuMTc1OCAxOC4yODUyIDIzLjYxNzIgMTYuOTUzMVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo="
      alt="default"
      class="chat-launch-icon"
    />
  </div>
</template>

<script>
export default {
  props: {
    theme: {
      type: String,
      default: 'default',
    },
    popUpZIndex: {
      type: Number,
      default: null,
    },
    dealerId: {
      type: String,
      default: null,
    },
    dealerName: {
      type: String,
      default: null,
    },
    adId: {
      type: String,
      default: null,
    },
    adUrl: {
      type: String,
      default: null,
    },
    pageUrlOverride: {
      type: String,
      default: null,
    },
    realmId: {
      type: Number,
      default: null,
    },
    linkName: {
      type: String,
      default: 'tchat-onpage-link',
    },
  },
  created() {
    this.loadTheme(this.theme)
  },
  computed: {
    launcherStyle() {
      return {
        'background-color': this.$styles.theme.buttons.launcher.backgroundColor,
      }
    },
  },
  methods: {
    openChat() {
      let parameters = {}

      if (this.popUpZIndex !== null) {
        parameters.popUpZIndex = this.popUpZIndex
      }

      if (this.dealerId !== null) {
        parameters.dealerId = this.dealerId
      }
      if (this.dealerName !== null) {
        parameters.dealerName = this.dealerName
      }
      if (this.adId !== null) {
        parameters.adId = this.adId
      }
      if (this.adUrl !== null) {
        parameters.adUrl = this.adUrl
      }
      if (this.pageUrlOverride !== null) {
        parameters.pageUrlOverride = this.pageUrlOverride
      }
      if (this.realmId !== null) {
        parameters.realmId = this.realmId
      }
      parameters.linkName = this.linkName

      this.$events.triggerEvent('open-chat', parameters)
    },
    loadTheme() {
      this.$theme.setActiveTheme(this.theme)
      this.$styles.setTheme(this.$theme.getActiveTheme())
    },
  },
}
</script>

<style scoped>
.chat-bubble {
  font-family: 'Open Sans';
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background-position: 50%;
  -webkit-box-shadow: none;
  box-shadow: none;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.bubble-label {
  color: #ffffff;
  font-size: 14px;
  font-weight: bold;
}

.chat-launch-icon {
  width: 27px;
  height: 21px;
}
</style>
